module.exports = __webpack_public_path__ + "media/images/new/icons/simple_procedures-ec98952ae3635d659d60556dc213c8a6.png";